module.exports = __webpack_public_path__ + "img/视觉设计.570e6667.svg";